import { render, staticRenderFns } from "./ResizableDrawer.vue?vue&type=template&id=3e08dfac&scoped=true"
import script from "./ResizableDrawer.vue?vue&type=script&lang=js"
export * from "./ResizableDrawer.vue?vue&type=script&lang=js"
import style0 from "./ResizableDrawer.vue?vue&type=style&index=0&id=3e08dfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08dfac",
  null
  
)

export default component.exports